module.exports = __webpack_public_path__ + "img/94842.28c8b6d9.svg";